import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { SectionHead } from "../Reveal";

const FILTERS = ["Todos", "Comunicação Visual", "Gráfico", "Camisetas", "Adesivos", "Empresas"];

const WORKS = [
    { img: "/images/fachadas.jpg", cat: "Comunicação Visual", title: "Fachada comercial em ACM" },
    { img: "/images/envelopamento.jpg", cat: "Empresas", title: "Envelopamento de frota" },
    { img: "/images/cartoes.jpg", cat: "Gráfico", title: "Cartões de visita premium" },
    { img: "/images/camisetas.jpg", cat: "Camisetas", title: "Camisetas personalizadas" },
    { img: "/images/placas.jpg", cat: "Comunicação Visual", title: "Sinalização interna" },
    { img: "/images/adesivos.jpg", cat: "Adesivos", title: "Adesivos de recorte" },
    { img: "/images/banners.jpg", cat: "Comunicação Visual", title: "Banner de grande formato" },
    { img: "/images/uniformes.jpg", cat: "Empresas", title: "Uniformes para equipe" },
    { img: "/images/panfletos.jpg", cat: "Gráfico", title: "Panfletos e flyers" },
    { img: "/images/hero.jpg", cat: "Gráfico", title: "Impressão de grande formato" },
    { img: "/images/b2b.jpg", cat: "Empresas", title: "Kit de materiais corporativos" },
];

export const Portfolio = () => {
    const [filter, setFilter] = useState("Todos");
    const visible = filter === "Todos" ? WORKS : WORKS.filter((w) => w.cat === filter);

    return (
        <section id="portfolio" data-testid="portfolio-section" className="grain relative bg-ink py-20 sm:py-28 lg:py-32 text-white">
            <div className="container-x">
                <SectionHead
                    dark
                    tag="04 — Portfólio"
                    title="Trabalhos que colocam marcas em evidência."
                    sub="Uma amostra dos tipos de projeto que produzimos para empresas de Campinas e região."
                />

                <div data-testid="portfolio-filters" className="mt-10 flex flex-wrap gap-2.5">
                    {FILTERS.map((f) => (
                        <button
                            key={f}
                            onClick={() => setFilter(f)}
                            data-testid={`portfolio-filter-${f.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/\s+/g, "-")}`}
                            className={`rounded-full border px-5 py-2.5 text-xs font-bold uppercase tracking-wider transition-all duration-300 ${
                                filter === f
                                    ? "border-brand bg-brand text-white"
                                    : "border-line text-mist hover:border-white/40 hover:text-white"
                            }`}
                        >
                            {f}
                        </button>
                    ))}
                </div>

                <motion.div layout className="mt-10 columns-2 gap-4 lg:columns-3 [column-fill:balance]">
                    <AnimatePresence mode="popLayout">
                        {visible.map((w) => (
                            <motion.figure
                                layout
                                key={w.title}
                                initial={{ opacity: 0, scale: 0.96 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.96 }}
                                transition={{ duration: 0.45 }}
                                data-testid={`portfolio-item-${w.title.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/\s+/g, "-")}`}
                                className="group relative mb-4 break-inside-avoid overflow-hidden rounded-xl border border-line"
                            >
                                <img
                                    src={w.img}
                                    alt={`${w.title} — IMPRIMA AKI Campinas`}
                                    loading="lazy"
                                    className="w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
                                />
                                <figcaption className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-ink/90 via-ink/20 to-transparent p-5 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                                    <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-brand">{w.cat}</span>
                                    <span className="mt-1 font-display text-base font-bold text-white">{w.title}</span>
                                </figcaption>
                            </motion.figure>
                        ))}
                    </AnimatePresence>
                </motion.div>
            </div>
        </section>
    );
};
